import {
  ADD_NEW_BED,
  CONVERT_TO_MULTIBED_PROJECT,
  RENAME_BED,
  SET_SELECTED_BED,
  DELETE_BED,
  SHOW_UNSAVED_CHANGES_DIALOG,
  HIDE_UNSAVED_CHANGES_DIALOG,
  SET_SELECTED_TAB_KEY,
  UPDATE_PLACEHOLDER,
  DELETE_PLACEHOLDER,
  LOADING_BED,
  LOADING_MULTIBED_PROJECT,
  UPDATE_BED_SAVE_AS,
  IS_DIRTY,
  HIDE_VOLUMES_COMPONENT,
  SET_MULTI_BED_OTHER_USER_DATA,
  SET_MULTI_BED_DESKTOP_ENABLED,
  SET_UPDATE_PERIMETER,
  UPDATE_MULTIBED_SCALE,
  SHOW_MULTIBED_SCALE_DIALOG,
  UPDATE_SELECTED_BED,
  UPDATE_BEDS_PAYLOAD,
  SET_OVERALL_TOTAL
} from "../lib/types";

export const convertToMultiBedProject = () => dispatch => {
  dispatch({
    type: CONVERT_TO_MULTIBED_PROJECT
  });
};

export const setSelectedBed = ( bedId ) => dispatch => {
  dispatch({
    type: SET_SELECTED_BED,
    payload: bedId
  });
};

export const updatedBedValues = ( bedId, isChamber, props ) => dispatch => {
  const updatedBedTotals = {
    volume: props["systemVolume"],
    length: props["systemLength"],
    width: props["systemWidth"],
    area: props["systemArea"],
    chambers: isChamber ? props["requiredChambers"] : 0,
    endCaps: isChamber ? props["requiredEndCaps"] : 0,
    numberOfPipeRows: !isChamber ? props["numberOfPipeRows"] : 0,

    lengthOutsideFittings: !isChamber ? props["pipeBedPipeBedDimensions"].height.ft : 0,
    lengthBetweenFittings: !isChamber ? props["pipeRowBedDimensions"].height.ft : 0,

    lengthFittingsOnCenter: !isChamber ? props["pipeBedCenterFittingDimensions"].height.ft : 0,
    chamberTypeName: props["chamberTypeName"],
    pipeTypeName: props["pipeTypeName"],
    pipeSizeNominalDiameter: props["pipeSizeNominalDiameter"]
  };

  dispatch({
    type: UPDATE_SELECTED_BED,
    payload: { bedId, updatedBedTotals }
  });
};

/**
 * Only used for MultiBedService.syncBedsData()
 * @param bedId
 * @param updatedBedsValues
 * @returns {(function(*): void)|*}
 */
export const updatedSelectedBedValues = ( updatedBedsValues ) => dispatch => {
  dispatch({
    type: UPDATE_BEDS_PAYLOAD,
    payload: { updatedBedsValues }
  });
};

export const addNewBed = ( id, name, placeholderSettings, calcs ) => dispatch => {
  dispatch({
    type: ADD_NEW_BED,
    payload: { id, name, placeholderSettings, calcs }
  });
};

export const renameBed = ( id, name ) => dispatch => {
  dispatch({
    type: RENAME_BED,
    payload: { id, name }
  });
};

export const deleteBed = ( id ) => dispatch => {
  dispatch({
    type: DELETE_BED,
    payload: id
  });
};

export const updatePlaceholder = ( placeholderSettings ) => dispatch => {
  dispatch({
    type: UPDATE_PLACEHOLDER,
    payload: { placeholderSettings }
  });
};

export const deletePlaceholder = ( placeholderId ) => dispatch => {
  dispatch({
    type: DELETE_PLACEHOLDER,
    payload: { placeholderId }
  });
};

export const loadingBed = ( loadingBed ) => dispatch => {
  dispatch({
    type: LOADING_BED,
    payload: { loadingBed }
  });
};

export const loadingMultiBedProject = ( loadingMultiBedProject ) => dispatch => {
  dispatch({
    type: LOADING_MULTIBED_PROJECT,
    payload: { loadingMultiBedProject }
  });
};

export const deleteTempBed = () => dispatch => {
  dispatch({
    type: DELETE_BED,
    payload: "temp-bed"
  });
};

export const setSelectedTabKey = ( id ) => dispatch => {
  dispatch({
    type: SET_SELECTED_TAB_KEY,
    payload: id
  });
};

export const showUnsavedChangesDialog = () => ( dispatch ) => {
  dispatch({
    type: SHOW_UNSAVED_CHANGES_DIALOG
  });
};

export const setDirtyStateForMultiBeds = ( booleanValue ) => ( dispatch ) => {
  dispatch({
    type: IS_DIRTY,
    payload: booleanValue
  });
};

export const hideVolumesComponentForMultiBeds = ( booleanValue ) => ( dispatch ) => {
  dispatch({
    type: HIDE_VOLUMES_COMPONENT,
    payload: booleanValue
  });
};

export const hideUnsavedChangesDialog = () => ( dispatch ) => {
  dispatch({
    type: HIDE_UNSAVED_CHANGES_DIALOG
  });
};

export const updateBedForSaveAs = ( bedMetaData ) => ( dispatch ) => {
  dispatch({
    type: UPDATE_BED_SAVE_AS,
    payload: { bedMetaData }

  });
};

export const setMultiBedOtherUserData = ( id, tokens ) => ( dispatch ) => {
  dispatch({
    type: SET_MULTI_BED_OTHER_USER_DATA,
    payload: { id, tokens }
  });
};

export const setMultiBedDesktopEnabled = ( isFromDesktop, enabled ) => ( dispatch ) => {
  dispatch({
    type: SET_MULTI_BED_DESKTOP_ENABLED,
    payload: { isFromDesktop, enabled }
  });
};

export const setUpdatePerimeterOnBed = ( value ) => ( dispatch ) => {
  dispatch({
    type: SET_UPDATE_PERIMETER,
    payload: { updatePerimeterOnBed: value }
  });
};

export const startRescaleMultibeds = ( value ) => ( dispatch ) => {
  dispatch({
    type: UPDATE_MULTIBED_SCALE,
    payload: { rescaleMultibeds: value }
  });
};

export const showScaleMultiBedWarningDialog = ( value ) => ( dispatch ) => {
  dispatch({
    type: SHOW_MULTIBED_SCALE_DIALOG,
    payload: { showScaleMultiBedWarning: value }
  });
};

export const setOverallTotal = ( overallValue ) => dispatch => {
  dispatch({
    type: SET_OVERALL_TOTAL,
    payload: overallValue
  });
};



// WEBPACK FOOTER //
// ./src/actions/multi-bed-actions.js